import { render, staticRenderFns } from "./ArtworkIntakeFormPublic.vue?vue&type=template&id=fef9dba8&scoped=true&"
import script from "./ArtworkIntakeFormPublic.vue?vue&type=script&lang=js&"
export * from "./ArtworkIntakeFormPublic.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkIntakeFormPublic.vue?vue&type=style&index=0&id=fef9dba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef9dba8",
  null
  
)

export default component.exports